import axios from "axios";
import authHeader from "./auth.header";
const API_URL = "https://contabilidadelider.com/api/dashboard/";
class DashService {
    stats() {
        return axios.get(API_URL + "stats", { headers: authHeader() });
    }
    /* register(user) {
    return axios.post(API_URL + 'signup', {
      username: user.username,
      email: user.email,
      password: user.password
    });
  }*/
}

export default new DashService();
